export default __webpack_public_path__ + "static/media/010208202136102.52af09f3.png";